import React from 'react';
import { HeaderDesktop } from '../../../common/components/header';
import HeaderNavigation from '../../../common/components/header-navigation';
import SearchHeader from './search-header';

type Props = Omit<
  React.ComponentProps<typeof SearchHeader>,
  'component' | 'left' | 'inputClassName' | 'borderClassName' | 'iconClassName'
>;

const SearchDesktopHeader = (props: Props) => (
  <SearchHeader
    component={HeaderDesktop}
    left={<HeaderNavigation />}
    inputClassName="blog-desktop-header-search-text-color blog-desktop-header-search-font"
    borderClassName="blog-desktop-header-search-border-background-color"
    iconClassName="blog-desktop-header-search-icon-fill"
    {...props}
  />
);

export default SearchDesktopHeader;
